:host {
  display: contents;
}

.spw-header-navigation {
  display: none;
  left: 0;
  width: 100%;
  height: calc(100% - 80px);
  background: white;
  z-index: 9999;
  overflow-y: auto;
  order: 2;
  border-top: 1px solid var(--spw-colors-support-grey-grey-300);
  border-bottom: 1px solid var(--spw-colors-support-grey-grey-300);
  :host(.spw-ds-nav-open) & {
    display: flex;
    flex-direction: column;
  }
  @include breakpoint(lg) {
    order: initial;
    display: block;
    height: auto;
    width: auto;
    overflow-y: initial;
    top: auto;
    left: auto;
    z-index: 30;
  }
  &__list {
    position: relative;
    display: flex;
    flex: 1;
    align-items: center;
    flex-direction: column;
    @include breakpoint(lg) {
      flex-direction: row;
      justify-content: space-between;
    }
    &-back {
      display: flex;
      justify-content: left;
      width: 100%;
      padding: 24px 16px;
      padding-bottom: 0;
      position: relative;
      z-index: 3;
      &:after {
        content: '';
        position: absolute;
        bottom: -1px;
        width: 100%;
        left: 0;
        height: 1px;
        background: white;
      }
      a {
        gap: 8px;
        display: flex;
        justify-content: left;
        align-items: center;
        font-weight: 700;
        font-size: 14px;
        text-decoration: none;
        color: var(--spw-colors-support-grey-grey-900);
        span {
          text-decoration: underline;
        }
        spw-icon {
          font-size: 18px;
        }
      }
      @include breakpoint(lg) {
        display: none;
      }
    }
  }
}
